<script setup>
import CarsTabs from '@/components/CarsTabs.vue';
import DealersAndDistributorsTabs from '@/components/DealersAndDistributorsTabs.vue';
defineProps({
  nav: {
    type: Object,
    default: () => {},
  },
});
</script>

<template>
  <nav class="header__nav">
    <ul class="m-0 p-0 header__nav-items">
      <li
        v-for="navItem in nav"
        :key="navItem.title"
        class="m-0 header__nav-item"
      >
        <template
          v-if="
            (navItem.children && navItem.children.length > 0) ||
            navItem.type === 'cars'
          "
        >
          <div
            v-if="navItem.type === 'cars'"
            class="header__nav-item-parent"
            :class="{
              'header__nav-item-parent--with-children':
                navItem.children && navItem.children.length > 0,
            }"
          >
            <span
              class="header__nav-item-link link-small"
              v-html="navItem.title"
            ></span>
            <CIcon
              name="arrow-small-black"
              width="8"
              height="8"
              class="header__nav-item-button"
            />
          </div>
          <CTagDetect
            v-else
            :to="navItem.url"
            class="header__nav-item-link link-small"
            >{{ navItem.title }}
          </CTagDetect>
          <template v-if="navItem.type === 'cars'">
            <div class="header__subnav header__subnav--cars">
              <div class="header__subnav-items">
                <ScrollPanel class="header__subnav-scrollpanel">
                  <CarsTabs :data="navItem.cars" />
                </ScrollPanel>
                <ScrollPanel class="header__subnav-scrollpanel">
                  <DealersAndDistributorsTabs
                    :data="navItem.brands"
                    :view="'nav'"
                  />
                </ScrollPanel>
              </div>
            </div>
          </template>
          <template v-else>
            <div
              v-if="navItem.children && navItem.children.length > 0"
              class="header__subnav"
            >
              <ul class="m-0 p-0 header__subnav-items">
                <li
                  v-for="item in navItem.children"
                  :key="item"
                  class="m-0 header__subnav-item"
                >
                  <CTagDetect
                    :to="item.url"
                    class="header__subnav-item-link link-normal"
                    :class="{
                      'header__subnav-item-link--general':
                        item.type === 'general',
                    }"
                    >{{ item.title }}
                    <CIcon
                      v-if="item.type === 'general'"
                      class="header__subnav-item-icon"
                      name="arrow-red"
                      width="16"
                      height="16"
                    />
                  </CTagDetect>
                </li>
              </ul>
            </div>
          </template>
        </template>
        <template v-else>
          <CTagDetect :to="navItem.url" class="header__nav-item-link link-small"
            >{{ navItem.title }}
          </CTagDetect>
        </template>
      </li>
    </ul>
  </nav>
</template>
<style scoped lang="scss">
.header {
  $parent: &;
  &__nav {
    display: none;
    @include media-breakpoint-up(md) {
      display: block !important;
    }
    &-items {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      list-style: none;
    }
    &-item {
      position: relative;
      &:hover {
        #{$parent} {
          &__nav {
            &-item {
              &-link {
                color: $primary;
                &:before {
                  background-color: $primary;
                }
              }
              &-button {
                transform: rotate(-180deg);
                &:deep(path) {
                  stroke: $primary;
                }
              }
            }
          }
          &__subnav {
            opacity: 1;
            pointer-events: auto;
            visibility: visible;
          }
        }
      }
      &-parent {
        align-items: center;
        display: grid;
        gap: 8px;
        grid-template-columns: auto 8px;
        @include media-breakpoint-up(xl) {
          @include responsive-spacing(gap, 8);
          grid-template-columns: auto px-to-vw(8);
        }
      }
      &-link {
        align-items: center;
        cursor: pointer;
        display: grid;
        gap: 8px;
        grid-template-columns: 4px auto;
        padding: 13px 0;
        text-transform: uppercase;
        &:before {
          background-color: $black;
          content: '';
          display: block;
          height: 4px;
          width: 4px;
        }
        @include media-breakpoint-up(xl) {
          @include responsive-spacing(gap, 8);
          @include responsive-spacing(padding-top, 13);
          @include responsive-spacing(padding-bottom, 13);
          grid-template-columns: px-to-vw(4) auto;
          &:before {
            @include responsive-spacing(height, 4);
            @include responsive-spacing(width, 4);
          }
        }
      }
      &-button {
        cursor: pointer;
        height: auto;
        transition: transform 0.3s ease;
        width: 100%;
      }
    }
  }
  &__subnav {
    $parentsub: &;
    background-color: $white;
    border-radius: 4px;
    box-shadow: 0px 4px 36px 0px #00000026;
    display: block;
    left: calc(50% - 80px);
    min-width: 256px;
    padding: 8px 0 4px;
    position: absolute;
    top: 100%;
    width: 100%;
    z-index: 2;
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    transition: opacity 0.3s;
    &-items {
      list-style: none;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(border-radius, 4);
      @include responsive-spacing(min-width, 256);
      @include responsive-spacing(padding-top, 8);
      @include responsive-spacing(padding-bottom, 4);
      left: calc(50% - px-to-vw(80));
    }
    &--cars {
      left: 0px;
      padding: 0;
      width: calc(100vw - 96px);
      @include media-breakpoint-up(lg) {
        width: 1184px;
      }
      @include media-breakpoint-up(xl) {
        @include responsive-spacing(width, 1184);
      }
      &:before {
        background-color: $divider;
        content: '';
        height: 100%;
        left: 65.42%;
        position: absolute;
        top: 0px;
        right: 0;
        width: 1px;
        @include media-breakpoint-up(xl) {
          @include responsive-spacing(width, 1);
        }
      }
      #{$parent} {
        &__subnav-scrollpanel {
          max-height: calc(100vh - 150px);
          overflow-y: auto;
          @include media-breakpoint-up(xl) {
            max-height: calc(100vh - px-to-vw(150));
          }
        }
        &__subnav-items {
          display: grid;
          grid-template-columns: 7.85fr 4.15fr;
        }
      }
    }
    &-item {
      &-icon {
        height: auto;
        width: 100%;
      }
      &-link {
        color: $on-surface-variant-2;
        display: block;
        padding: 12px 16px;
        transition: all 0.3s linear;
        &--general {
          align-items: center;
          color: $black;
          display: grid;
          gap: 8px;
          grid-template-columns: max-content 16px;
          margin-top: 4px;
          padding: 16px;
        }
        &:hover {
          background-color: $gray;
          color: $primary;
        }
        @include media-breakpoint-up(xl) {
          @include responsive-spacing(padding-top, 12);
          @include responsive-spacing(padding-bottom, 12);
          @include responsive-spacing(padding-left, 16);
          @include responsive-spacing(padding-right, 16);
          &--general {
            @include responsive-spacing(gap, 8);
            @include responsive-spacing(margin-top, 4);
            @include responsive-spacing(padding, 16);
            grid-template-columns: max-content px-to-vw(16);
          }
        }
      }
    }
  }
}
</style>
